const platform = 'web';
const buildNumber = undefined;
const appVersion = undefined;

export const platformInfo = {
    platform,
    buildNumber,
    appVersion,
};
